module.exports = __webpack_public_path__ + "img/icon-jinjutiyanke-logo.66d4f950.png";